import { Component } from '@angular/core';
import { MAPSContactMessageEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Contact Messages') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapscontactmessage-form',
    templateUrl: './mapscontactmessage.form.component.html'
})
export class MAPSContactMessageFormComponent extends BaseFormComponent {
    public record!: MAPSContactMessageEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'contactMessageEvents', sectionName: 'Contact Message Events', isExpanded: false }
        ]);
    }
}

